import React from "react";
import { Github, Linkedin, Heart } from "lucide-react";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <footer className="glass border-t border-white/5 py-8 mt-auto">
      <div className="container mx-auto px-4 md:px-8 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-neutral-400 font-medium">
          Designed with <Heart size={16} className="inline text-primary animate-pulse mx-1" /> by 
          <span className="text-white ml-1">Vijay Benal</span>
        </div>

        <div className="text-neutral-500 text-sm">
          Copyright © {year} <span className="text-primary/50 text-xs ml-2">VB</span>
        </div>

        <div className="flex items-center gap-6">
          <a
            href="https://github.com/vijay5599"
            target="_blank"
            rel="noopener noreferrer"
            className="text-neutral-400 hover:text-primary transition-colors hover:scale-110"
            aria-label="GitHub"
          >
            <Github size={22} />
          </a>
          <a
            href="https://www.linkedin.com/in/vijay-v-benal-184926169/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-neutral-400 hover:text-primary transition-colors hover:scale-110"
            aria-label="LinkedIn"
          >
            <Linkedin size={22} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
